export const formatDirectorName = (
  prefix: string,
  firstName: string,
  middleName: string | null,
  lastName: string,
): string => {
  const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ');
  return [prefix, fullName].filter(Boolean).join(' ');
};
